import { FundDocument } from '~/api/def/endpoints/fundEndpoint';

export function OpenDocumentOverviewCell(props: {
  value: string;
  data: FundDocument;
  showDocumentOverview: (documentId: string) => void;
}) {
  // console.log(props);
  if (!props.value) {
    return '-';
  }
  return (
    <span
      className="underline-on-hover"
      onClick={() => {
        return props.showDocumentOverview(props.data.id);
      }}
    >
      {props.value}
    </span>
  );
}
